import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55f24133"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tournaments-not-available",
  "data-qe-id": "tournaments-not-available"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calendar" }, null, -1))
const _hoisted_3 = { class: "content" }

import { marked } from 'marked'


export default /*#__PURE__*/_defineComponent({
  __name: 'CTournamentsNotAvailable',
  setup(__props) {

function md(text: string) {
  return marked(text)
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_container = _resolveComponent("t-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_t_container, { class: "narrow-container" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_t_text, {
            innerHTML: md(_ctx.$t('tNotAvailable.main.text'))
          }, null, 8, ["innerHTML"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})